/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Steps, Empty } from 'antd';
import PropTypes from 'prop-types';
import { CheckOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import colors from '../../constants/Colors';

import { safeExtractFromObject } from '../../helpers/helpers';

const { Step } = Steps;

export default function StepsContainer({
  currentStep = 0,
  steps = [],
  style = {},
  containerStyle = {},
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const hasRedesign = settings?.uxRedesignPt1;

  return (
    <div style={{ height: '100%', width: '100%', ...containerStyle }}>
      <Steps
        size="small"
        current={currentStep}
        style={{ marginBottom: 30, ...style }}
        className={hasRedesign ? 'steps-redesign' : ''}
      >
        {steps.map(({ title }, index) => {
          const innerStyle = {
            height: 24, width: 24, lineHeight: '24px', borderRadius: 24, marginRight: 5,
          };
          let className = hasRedesign
            ? 'ant-steps-redesign'
            : 'ant-steps-small ant-steps-item-icon';
          let titleClass = hasRedesign ? 'steps-title' : '';
          let body = index + 1;
          if (currentStep === index) {
            className += ' steps-current';
            innerStyle.backgroundColor = colors.ONTRACCR_DARK_YELLOW;
            innerStyle.color = 'black';
          } else if (currentStep > index) {
            className += ' steps-done';
            innerStyle.border = `1px solid ${colors.ONTRACCR_DARK_YELLOW}`;
            if (!hasRedesign) {
              body = <CheckOutlined style={{ color: colors.ONTRACCR_DARK_YELLOW, transform: 'translateY(-1px)' }} />;
            }
          } else {
            className += ' steps-next';
            titleClass += ' steps-next';
            innerStyle.border = '1px solid lightgray';
          }
          return (
            <Step
              key={title}
              title={(
                <span
                  className={hasRedesign ? titleClass : null}
                >
                  {title}
                </span>
              )}
              icon={(
                <span
                  className={className}
                  style={hasRedesign ? null : innerStyle}
                >
                  {body}
                </span>
              )}
            />
          );
        })}
      </Steps>
      {
        steps.map(({ content }, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            style={{
              display: index === currentStep ? 'block' : 'none',
            }}
          >
            {content}
          </div>
        )).concat(
          <Empty key="steps-empty" style={{ display: steps ? 'none' : 'block' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />,
        )
      }
    </div>
  );
}

StepsContainer.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.node,
    }),
  ),
  style: PropTypes.object,
  containerStyle: PropTypes.object,
};

StepsContainer.defaultProps = {
  currentStep: 0,
  steps: [],
  style: {},
  containerStyle: {},
};
